<script>
import { Line, mixins } from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartData() {
      try {
        if (this.chartData !== null)
          this.renderChart(this.chartData, this.options);
      } catch (ex) {
        console.log(ex);
      }
    },
  },
  data() {
    return {
      timoutHandle: null,
    };
  },
  mounted() {
    try {
      if (this.chartData !== null) {
        this.renderChart(this.chartData, this.options);
      }
    } catch (ex) {
      console.log(ex);
    }
  },
  methods: {},
};
</script>
